// ==========================================================
// CTA.jsx
// ORION BEACH HOTEL · KITE HOUSE
// CTA + UBICACIÓN + MAPA
// ==========================================================

import {
  ArrowRight,
  MapPin,
  MessageCircle,
  Navigation,
  Sparkles,
  Waves,
} from "lucide-react";

import "../styles/cta.css";


// ==========================================================
// COMPONENT
// ==========================================================

export default function CTA({ content }) {

  // ========================================================
  // WHATSAPP
  // ========================================================

  const phone =
    content?.phone ||
    "573104794943";


  const message = encodeURIComponent(
    content?.message ||
      "Hola, quiero consultar disponibilidad y reservar mi estadía en Orion Beach Hotel · Kite House."
  );


  // ========================================================
  // CONTENT
  // ========================================================

  const badge =
    content?.badge ||
    "ORION BEACH HOTEL · KITE HOUSE";


  const title =
    content?.title ||
    "Tu próxima aventura comienza frente al mar";


  const text =
    content?.text ||
    "Disfruta La Guajira, el viento, el mar y la tranquilidad de una experiencia única en Orion Beach Hotel · Kite House.";


  const urgent =
    content?.urgent ||
    "Reserva tu estadía y descubre la magia de Mayapo.";


  const button =
    content?.button ||
    "Consultar disponibilidad";


  const micro =
    content?.micro ||
    "Atención personalizada · Reservas directas";


  // ========================================================
  // LOCATION
  // ========================================================

  const locationTitle =
    content?.location_title ||
    "Estamos en Mayapo";


  const locationText =
    content?.location_text ||
    "La Guajira · Colombia";


  const locationAddress =
    content?.location_address ||
    "Mayapo, La Guajira, Colombia";


  // ========================================================
  // MAP
  // ========================================================
  //
  // Se puede reemplazar desde el API mediante:
  //
  // content.map_url
  //
  // Si no existe, usamos una ubicación de Mayapo.
  //
  // ========================================================

  const mapUrl =
    content?.map_url ||
    "https://www.google.com/maps?q=Mayapo,+La+Guajira,+Colombia&output=embed";


  const mapsUrl =
    content?.maps_url ||
    "https://www.google.com/maps/search/?api=1&query=Mayapo%2C%20La%20Guajira%2C%20Colombia";


  // ========================================================
  // RENDER
  // ========================================================

  return (

    <section
      className="cta"
      id="cta"
      aria-labelledby="cta-title"
    >

      {/* ====================================================
          AMBIENT LIGHT
      ==================================================== */}

      <div
        className="cta__ambient cta__ambient--top"
        aria-hidden="true"
      />

      <div
        className="cta__ambient cta__ambient--bottom"
        aria-hidden="true"
      />


      {/* ====================================================
          DECORATIVE LINE
      ==================================================== */}

      <div
        className="cta__line"
        aria-hidden="true"
      />


      {/* ====================================================
          MAIN GRID
      ==================================================== */}

      <div className="cta__grid">


        {/* ==================================================
            LEFT · CTA
        ================================================== */}

        <div className="cta__card">

          {/* ================================================
              TOP DECORATION
          ================================================ */}

          <div
            className="cta__top-decoration"
            aria-hidden="true"
          >

            <span />

            <Waves size={17} />

            <span />

          </div>


          {/* ================================================
              BADGE
          ================================================ */}

          <div className="cta__badge">

            <span className="cta__badge-dot" />

            <span>
              {badge}
            </span>

          </div>


          {/* ================================================
              TITLE
          ================================================ */}

          <h2
            className="cta__title"
            id="cta-title"
          >
            {title}
          </h2>


          {/* ================================================
              TEXT
          ================================================ */}

          <p className="cta__text">
            {text}
          </p>


          {/* ================================================
              HIGHLIGHT
          ================================================ */}

          <div className="cta__urgent">

            <span className="cta__urgent-icon">

              <Sparkles size={14} />

            </span>

            <p>
              {urgent}
            </p>

          </div>


          {/* ================================================
              ACTION
          ================================================ */}

          <div className="cta__actions">

            <a
              href={`https://wa.me/${phone}?text=${message}`}
              className="cta__button"
              target="_blank"
              rel="noopener noreferrer"
              aria-label={`${button} por WhatsApp`}
            >

              <span className="cta__button-icon">

                <MessageCircle size={19} />

              </span>

              <span className="cta__button-text">

                {button}

              </span>

              <span className="cta__button-arrow">

                <ArrowRight size={18} />

              </span>

            </a>

          </div>


          {/* ================================================
              MICRO COPY
          ================================================ */}

          <p className="cta__micro">
            {micro}
          </p>


          {/* ================================================
              BOTTOM DECORATION
          ================================================ */}

          <div
            className="cta__bottom-decoration"
            aria-hidden="true"
          >

            <span />
            <span />
            <span />

          </div>

        </div>


        {/* ==================================================
            RIGHT · LOCATION
        ================================================== */}

        <div className="cta__location">


          {/* ================================================
              LOCATION HEADER
          ================================================ */}

          <div className="cta__location-header">

            <div className="cta__location-icon">

              <MapPin size={20} />

            </div>


            <div>

              <span className="cta__location-eyebrow">
                NUESTRA UBICACIÓN
              </span>

              <h3>
                {locationTitle}
              </h3>

              <p>
                {locationText}
              </p>

            </div>

          </div>


          {/* ================================================
              MAP
          ================================================ */}

          <div className="cta__map">

            <iframe
              src={mapUrl}
              title="Ubicación de Orion Beach Hotel · Kite House"
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />

            {/* ==============================================
                MAP OVERLAY
            ============================================== */}

            <div
              className="cta__map-overlay"
              aria-hidden="true"
            >

              <div className="cta__map-pin">

                <MapPin size={18} />

              </div>

            </div>

          </div>


          {/* ================================================
              ADDRESS
          ================================================ */}

          <div className="cta__location-footer">

            <div className="cta__location-address">

              <Navigation size={15} />

              <span>
                {locationAddress}
              </span>

            </div>


            <a
              href={mapsUrl}
              className="cta__location-button"
              target="_blank"
              rel="noopener noreferrer"
            >

              <span>
                Cómo llegar
              </span>

              <ArrowRight size={15} />

            </a>

          </div>

        </div>

      </div>


      {/* ====================================================
          FOOTER
      ==================================================== */}

      <div className="cta__footer">

        <span>
          LA GUAJIRA · COLOMBIA
        </span>

        <i />

        <span>
          MAYAPO
        </span>

        <i />

        <span>
          ORION BEACH HOTEL · KITE HOUSE
        </span>

      </div>

    </section>

  );

}